<template>
	<div class="not-review-topics">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<!-- <div class="row">
              <div class="col-12">
                <div class="page-title-box">
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript: void(0);">首页</a></li>
                      <li class="breadcrumb-item">课题申报</li>
                      <li class="breadcrumb-item"><a href="javascript: void(0);">专家评分</a></li>
                      <li class="breadcrumb-item active">待评审课题</li>
                    </ol>
                  </div>
                  <h3 class="header-title mb-3">待评审课题</h3>
                </div>
              </div>
            </div> -->
						<div class="row mb-1">
							<div class="col-xl-6">待评审课题</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<p>
											说明：本次评审从
											<span class="text-danger">{{ projectData.reviewStartTime }}</span>
											开始，
											<span class="text-danger">{{ projectData.reviewEndTime }}</span>
											结束。
										</p>
										<div class="flex_between">
											<div class="mb-2">
												<span class="mr-2 mb-1">课题名称:</span>
												<el-input class="mr-2 mb-1" v-model="query.declareName" placeholder="请输入课题名称" size="small" style="width: 180px"></el-input>
												<!-- <span class="mr-2 mb-1">立项建议:</span>
												<el-select class="mr-2 mb-1" v-model="query.projectTypeId" @change="searchType" placeholder="-请选择-" clearable size="small">
													<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select> -->
												<el-button class="ml-2 mb-1" type="success" size="small" @click="searchData">查询</el-button>
											</div>
											<div class="mb-2">
												<el-button v-if="list.length > 0 && projectData.isSubmit !== 1" class="mb-1" type="primary" icon="el-icon-upload2" size="small" @click="submitExpertReview">
													提交我的评审
												</el-button>
												<!-- <el-button v-if="list.length>0 && projectData.isSubmit!==1" class="mb-1"
													type="primary" icon="el-icon-upload2" size="small"
													@click="submitExpertReview">提交我的评审</el-button> -->
												<el-button v-else class="mb-1" type="info" icon="el-icon-upload2" size="small">已提交评审</el-button>
												
												<el-button v-if="list.length > 0" class="mb-1" type="primary" icon="el-icon-upload" size="small" @click="exportExcel">导出Excel</el-button>
											</div>
										</div>
										<div class="table-responsive">
											<el-table :header-cell-style="tableHeaderStyle" ref="multipleTable" :data="list" tooltip-effect="light" style="width: 100%" border>
												<el-table-column prop="projectManagementName" label="课题名称" min-width="150">
													<template slot-scope="scope">
														<el-button type="text" @click="handleToDetail(scope.row)">{{ scope.row.projectManagementName }}</el-button>
													</template>
												</el-table-column>
												<el-table-column prop="projectTypeName" label="课题类别" min-width="100"></el-table-column>
												<el-table-column prop="researchFieName" label="研究领域" min-width="100"></el-table-column>
												<el-table-column prop="learningTypeName" label="学段" min-width="80"></el-table-column>
												<el-table-column prop="score" label="我的评分" min-width="80"></el-table-column>
												<!-- <el-table-column prop="type" label="立项建议" min-width="100">
													<template slot-scope="scope">
														<span class="text-danger" v-if="scope.row.type == '0'">不建议立项</span>
														<span class="text-success" v-if="scope.row.type == '1'">建议立项</span>
													</template>
												</el-table-column> -->
												<el-table-column prop="note" label="评语" min-width="80">
													<template slot-scope="scope">
														<el-button v-if="scope.row.note" type="text" @click="handleLookNote(scope.row.note)">查看</el-button>
													</template>
												</el-table-column>
												<el-table-column label="操作" min-width="80">
													<template slot-scope="scope">
														<el-button v-if="scope.row.type && scope.row.isSubmit !== 1" size="small" @click="handleToDetail(scope.row)">修改评分</el-button>
														<el-button v-if="!scope.row.type && scope.row.isSubmit !== 1" type="primary" size="small" @click="handleToDetail(scope.row)">评分</el-button>
													</template>
												</el-table-column>
											</el-table>
											<el-table
												v-show="false"
												id="exportTab"
												:header-cell-style="tableHeaderStyle"
												ref="multipleTable"
												:data="list"
												tooltip-effect="light"
												style="width: 100%"
												border
											>
												<el-table-column prop="id" label="序号" min-width="40"></el-table-column>
												<el-table-column prop="declareName" label="课题名称" min-width="150">
													<template slot-scope="scope">
														<el-button type="text" @click="handleToDetail(scope.row)">{{ scope.row.declareName }}</el-button>
													</template>
												</el-table-column>
												<el-table-column prop="projectTypeName" label="课题类别" min-width="100"></el-table-column>
												<el-table-column prop="researchFieName" label="研究领域" min-width="100"></el-table-column>
												<el-table-column prop="learningTypeName" label="学段" min-width="80"></el-table-column>
												<el-table-column prop="score" label="我的评分" min-width="80"></el-table-column>
												<el-table-column prop="type" label="立项建议" min-width="100">
													<template #default="scope">
														<span class="text-danger" v-if="scope.row.type == '0'">不建议立项</span>
														<span class="text-success" v-if="scope.row.type == '1'">建议立项</span>
													</template>
												</el-table-column>
												<el-table-column prop="note" label="评语" min-width="80"></el-table-column>
											</el-table>
										</div>

										<!-- 分页器 -->
										<div class="text-right mt-2">
											<el-pagination
												layout="total, sizes, prev, pager, next, jumper"
												background
												:current-page="query.pageNumber"
												:page-sizes="[10, 50, 100, 200]"
												:page-size="query.pageSize"
												:total="total"
												@size-change="handleSizeChange"
												@current-change="handlePageChange"
											></el-pagination>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getExpertScoreAuditList, submitExpertReview,submitExpertReviewNew } from '@/api/after/expertScore';
import { getReviewTopicList } from '@/api/after/topicManage.js'

import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
	name: 'topicList',
	components: { Breadcrumb },
	data() {
		return {
			tableHeaderStyle: { backgroundColor: '#7e9be2', color: '#fff' },
			typeOptions: [{ value: 1, label: '建议立项' }, { value: 0, label: '不建议立项' }],
			typeAction: '', //被选中的类型
			projectData: {}, //项目信息
			list: [],
			total: 0,
			// declareName: null,
			query: {
				declareName:'',//课题名称			
				groupId:'',//设置id			
				isSubmit:'',//是否提交评审(0:未提交)			
				pageNumber:1,//页码,默认为1,示例值(1)			
				pageSize:10,//页大小,默认为10,示例值(10)			
				type:'',//类型(0:不建议立项,1:建议立项)			
				typeName:'',//类型			
				userId:'',//用户id			
				settingId:'',//课题管理设置id
			}
		};
	},
	mounted() {
		this.projectData = JSON.parse(this.$route.query.data);
		console.log('接收数据',this.projectData);
		this.query.settingId = this.projectData.id;
		this.getData();
	},
	methods: {
		// 获取数据列表
		getData(isNum) {
			if (isNum) this.query.pageNumber = 1;
			getReviewTopicList(this.query).then(res => {
				if (res.code == 200) {
					console.log('课题列表',res);
					this.list = res.data.records;
					this.total = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 根据立项建议查询
		searchType(val) {
			if (val === '') {
				delete this.query.type;
			} else {
				this.query.type = val;
			}
			console.log(val, this.query);
		},
		// 查询
		searchData() {
			this.getData(true);
		},
		handleToDetail(data) {
			if (this.projectData.isSubmit == 1) {
				this.$message.error('已提交，不能进行评分');
				return;
			}
			this.$router.push({
				path: '/backstage/topicManageReviewTopicDetail',
				query: { data: JSON.stringify(data) }
			});
		},
		handleLookNote(data) {
			console.log(data);
			let text = data.replace(/\r?\n/g, '<br/>');
			this.$alert(text, '查看评语', {
				confirmButtonText: '确定',
				dangerouslyUseHTMLString: true
			});
		},
		toUpdate(data) {
			console.log(data);
		},
		// 提交专家评审
		submitExpertReview() {
			submitExpertReviewNew(this.query.settingId).then(res => {
				if (res.code == 200) {
					this.$message.success('提交成功');
					this.getData(true);
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 导出表格
		exportExcel() {
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '待评分课题表（项目名称：' + this.projectData.projectName + '）.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		// 分页导航
		handlePageChange(val) {
			this.query.pageNumber = val;
			this.getData();
		},
		handleSizeChange(val) {
			this.query.pageSize = val;
			this.getData(true);
		}
	}
};
</script>

<style scoped>
.flex_between {
	display: flex;
	justify-content: space-between;
}
/deep/.el-table th > .cell {
	text-align: center;
}
/deep/.el-table .cell {
	text-align: center;
}
</style>
